import React from 'react';
import { connect } from 'react-redux';
import {
  ReduxStateType,
  CmsPageContentIdentifier,
  ResultType,
  TariffOfferType,
} from '@/types/av-check';

export interface StateProps {
  title: string,
  intro: string,
  result?: ResultType,
  tariffOffers: TariffOfferType[],
}

const Head = ({
  title,
  intro,
  result,
  tariffOffers,
}: StateProps) => (
  <div className="article">
    <h1 dangerouslySetInnerHTML={{ __html: title }} />
    <div className="body-text">
      { (!result || !result.address || tariffOffers.length === 0)
        && <p dangerouslySetInnerHTML={{ __html: intro }} /> }
    </div>
  </div>
);

const mapStateToProps = (state: ReduxStateType) => ({
  title: state.cmsContent ? state.cmsContent[CmsPageContentIdentifier.Title] : '',
  intro: state.cmsContent ? state.cmsContent[CmsPageContentIdentifier.Intro] : '',
  result: state.result,
  tariffOffers: state.result?.tariffOffers || [],
});

export default connect(mapStateToProps)(Head);
